import Card from 'src/models/card/Card'
import Discount from 'src/models/discount/Discount'
import GiftCard from 'src/models/gift-card/GiftCard'
import Model, { ID } from 'src/models/model'
import IssuedVoucherPackage from 'src/models/voucher/IssuedVoucherPackage'
import Voucher from 'src/models/voucher/Voucher'
import VoucherType from 'src/models/voucher/VoucherType'

export const CHECKOUT_CODE_TYPES = {
  VOUCHER: 'voucher',
  GIFT_CARD: 'giftCard',
  ISSUED_VOUCHER_PACKAGE: 'issuedVoucherPackage',
  CARD: 'card',
  CEA_CARD: 'ceaCard',
  MEERKAT_MOVIE: 'meerkatMovie',
  THE_CINEMA_CLUB: 'theCinemaClub',
  DISCOUNT: 'discount',
  VOUCHER_TYPE: 'voucherType'
}

export const CHECKOUT_CODE_ERROR_CODES = {
  NOT_FOUND: 100,
  NOT_VALID: 101,
  EXPIRED: 102,
  REDEEMED: 103,
  LIMIT_REACHED: 104,
  UNAVAILABLE: 105,
  INTERNAL_ERROR: 106,
  UNHANDLED_ERROR: 200
}

export default class CheckoutCode extends Model {
  static name = 'CheckoutCode'

  static define () {
    this.fields = {
      valid: {
        type: Boolean,
        required: false,
        default: false,
        output: true
      },
      error: {
        type: String,
        required: false,
        default: null,
        output: true
      },
      errorCode: {
        type: Number,
        required: false,
        default: null,
        output: true
      },
      codeType: {
        type: String,
        required: false,
        default: null,
        output: true
      },
      voucher: {
        type: Voucher,
        required: false,
        default: null,
        output: true
      },
      giftCard: {
        type: GiftCard,
        required: false,
        default: null,
        output: true
      },
      issuedVoucherPackage: {
        type: IssuedVoucherPackage,
        required: false,
        default: null,
        output: true
      },
      card: {
        type: Card,
        required: false,
        default: null,
        output: true
      },
      ceaCard: {
        type: Boolean,
        required: false,
        default: false
      },
      meerkatMovie: {
        type: Boolean,
        required: false,
        default: false
      },
      theCinemaClub: {
        type: Boolean,
        required: false,
        default: false
      },
      discount: {
        type: Discount,
        required: false,
        default: null,
        output: true
      },
      voucherType: {
        type: VoucherType,
        required: false,
        reference: true,
        default: null,
        output: true
      }
    }

    this.queries = {
      validateCheckoutCode: {
        arguments: {
          code: {
            type: String,
            required: true
          },
          movieEdiCode: {
            type: String,
            required: false
          },
          movieIds: {
            type: [ID],
            required: false
          },
          recaptchaToken: {
            type: String,
            required: false
          },
          pin: {
            type: String,
            required: false
          }
        },
        results: {
          checkoutCode: CheckoutCode
        }
      }
    }
  }
}
